import { TokenAcceptFlow } from '../components/TokenAcceptFlow.js';

/**
 * The reset link, `/reset/<token>`: a public page where an existing account sets
 * a new password. Accepting it ends every other session and remembered device
 * and sends the person to sign in with their authenticator — the reset never
 * bypasses the second factor. The shared token-accept flow does the work.
 */
export function ResetPasswordPage() {
  return <TokenAcceptFlow kind="password_reset" />;
}
